import Component from './safety'

export default Component
